export class PendingCallError extends Error {
  constructor() {
    super('You can not restart widget during the call.');

    this.name = 'PendingCallError';
  }
}
